'use client';

import React, { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { CHECKIN_ENDPOINT } from '@/constants/endpoints.ts';
import { typedHttp } from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types.ts';
import { useCurrentUser } from '@/modules/user/useCurrentUser.ts';

export function InitUserCheckin() {
  const pathname = usePathname();
  const [_, user] = useCurrentUser();
  const userId = user?.id.toString() || '';

  function checkin(): Promise<AxiosCompatibleResponse<void>> {
    return typedHttp.put(CHECKIN_ENDPOINT, null, { withAuth: true });
  }

  useEffect(() => {
    if (userId) {
      checkin().catch(() => undefined);
    }
  }, [pathname, userId]);

  return <></>;
}
